import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FacadeService} from '../../shared/service/facade/facade.service';

@Component({
  selector: 'app-request-reset-password',
  templateUrl: './request-reset-password.component.html',
  styleUrls: ['./request-reset-password.component.css']
})
export class RequestResetPasswordComponent implements OnInit {

  usernameForm: UntypedFormGroup;
  usernameValidated = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private facadeService: FacadeService,
    private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.formBuilderValidations();
  }

  onSubmit() {
    if (this.usernameForm.valid) {
      this.facadeService.resetPassword(this.usernameForm.get('username').value, this.translate.currentLang)
        .subscribe({
          next: ignoreProperty => {
            this.usernameValidated = true;
          },
          error: ignoreProperty => {
            alert(this.translate.instant('login.resetPassword.message.error.connectionError'));
          }
        });
    }
  }

  backToMenu() {
    this.router.navigateByUrl('/login');
  }

  private formBuilderValidations() {
    this.usernameForm = this.formBuilder.group({
        username: ['', [Validators.required]]
      }
    );
  }
}
